export default __webpack_public_path__ + "static/margot_sheridan-3a5f4823760090f86aa34dbb609df6ed.jpg";